import { render, staticRenderFns } from "./HeightTransition.vue?vue&type=template&id=cdb5b572"
import script from "./HeightTransition.vue?vue&type=script&lang=ts"
export * from "./HeightTransition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports